import ScalarIconCaretDown_vue_vue_type_script_setup_true_lang_default from "./ScalarIconCaretDown.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconCaretDown.vue
var ScalarIconCaretDown_default = ScalarIconCaretDown_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconCaretDown_default as default };

//# sourceMappingURL=ScalarIconCaretDown.js.map